(()=>{
const root=document.querySelector('.ab[data-page="about"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const rawLang=document.documentElement.lang||'en';
let dict={};
try{dict=JSON.parse($('#ab-i18n').textContent)||{};}catch(e){dict={};}
const t=(key,vars)=>{let text=dict[key]||key;if(vars)for(const name in vars)text=text.split('{'+name+'}').join(vars[name]);return text;};

/* Mobile sticky action: shown only while the hero and close band are off screen. */
const sticky=$('.ab-mobile-action');const visible=new Map();
if(sticky&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:.05});
 [$('.ab-hero'),$('.ab-close')].forEach(section=>{if(section)observer.observe(section);});
}

/* Awards row scrolls sideways only on phones: make it a keyboard stop there and nowhere else. */
const awards=$('.ab-awards');
if(awards&&window.matchMedia){
 const phone=matchMedia('(max-width:767px)');
 const setStop=()=>{if(phone.matches)awards.setAttribute('tabindex','0');else awards.removeAttribute('tabindex');};
 setStop();
 if(phone.addEventListener)phone.addEventListener('change',setStop);
}
})();
